export default __webpack_public_path__ + "static/media/logo.d6e68d78.png";